module.exports = __webpack_public_path__ + "img/times.8e24e851.svg";